/**
 * @typedef {import("./Props").default} Props
 */

import { translate } from 'App/Internationalization';
import BaseButton from 'shared/BaseButton/BaseButton';
import BaseForm from 'shared/Forms/BaseForm';
import FieldRadio from 'shared/Forms/Fields/FieldRadio';
import FilterGroup from '../Types/FilterGroup';
import React from 'react';

/** @extends	{React.Component<Props>} */
export default class StatusFilter extends React.Component {
	/** @param {Props} props */
	constructor(props) {
		super(props);

		this.state = { active: false };

		this._handleSubmit = this._handleSubmit.bind(this);
		this._handleReset = this._handleReset.bind(this);
	}

	/** @param {{status: 'active' | 'disable'}} value */
	_handleSubmit(value) {
		if (this.props.disabled) {
			return;
		}

		this.props.onSubmit({
			'filter[status]': value.status,
		});

		this.setState({ active: true });
	}

	_handleReset() {
		if (this.props.disabled) {
			return;
		}

		this.props.onSubmit({
			'filter[status]': undefined,
		});

		this.setState({ active: false });
	}

	/** @returns {JSX.Element} */
	render() {
		return (
			<FilterGroup
				active={this.state.active}
				locked={this.props.gated}
				title={'Agents'}
			>
				<BaseForm noRequiredText={true} onSubmit={this._handleSubmit}>
					<div className="flex flex-col gap-4">
						<FieldRadio
							id="active"
							label={'Active'}
							name="status"
							required={false}
							value={'active'}
						/>
						<FieldRadio
							id="disable"
							label={'Disable'}
							name="status"
							required={false}
							value={'disable'}
						/>
						<FieldRadio
							id="all"
							label={'All Agent'}
							name="status"
							required={false}
							value={'all'}
						/>

						<div className="flex gap-2">
							<BaseButton
								className="w-fit"
								disabled={this.props.disabled}
								iconSize="small"
								size="xsmall"
								type="submit"
							>
								{translate('filters.submit')}
							</BaseButton>
							<BaseButton
								className="w-fit"
								disabled={this.props.disabled}
								iconSize="small"
								onClick={this._handleReset}
								outline={true}
								size="xsmall"
								type="reset"
							>
								{translate('filters.reset')}
							</BaseButton>
						</div>
					</div>
				</BaseForm>
			</FilterGroup>
		);
	}
}
